<template>
  <el-row class="white">
    <el-col :offset="1" :span="23">
      <query-form :form="form" v-model="boatKind" @handleQuery="handleQuery" />
    </el-col>
  </el-row>
  <base-table
    :columns="columns"
    :data="kindList"
    :pager="pager"
    :cell-style="cellStyle"
    :pageShow="pageShow"
    @handleAction="handleAction"
    @handleCurrentChange="handleCurrentChange"
  >
    <template v-slot:action>
      <el-row class="white">
        <el-col :span="2">
          <el-button type="primary" @click="shiftHandover">今日交班</el-button>
        </el-col>
        <el-col :offset="1" :span="2">
          <el-button @click="exportExcel"
            ><i class="el-icon-upload2"></i> <span>导出</span></el-button
          >
        </el-col>
        <el-col :offset="5" :span="12" class="valuation">
          <span class="mr20">总计时长(小时)</span>
          <span>{{
            total.timeDuration ? Number(total.timeDuration).toFixed(2) : 0
          }}</span>
          <span class="mr20">小时</span>
          <span class="mr20">总计金额(元)</span>
          <span>{{ total.inPrice ? total.inPrice : 0 }}元</span>
        </el-col>
      </el-row>
    </template>
  </base-table>
</template>

<script>
import { reactive, ref, getCurrentInstance } from "vue";
import utils from "@/utils/utils";
import useGuideTable from "@/hooks/useGuideTable";
import moment from "moment";
import { ElMessage } from 'element-plus';
export default {
  name: "dailyshifthandover",
  setup() {
    // 获取Composition API 上下文对象
    const { proxy } = getCurrentInstance();
    const total = ref({});
    let queryValue = {};
    const formInline = reactive({
      user: "",
      region: "",
      date1: "",
    });
    // 初始化表单对象
    const boatKind = ref({
      userId: "",
      wharfId: "",
      payWay: "",
      saleTime: new Date(),
    });
    // 查询事件， 获取码头列表
    const handleQuery = async (values) => {
      const condition = utils.checkParmas(values);
      if(!condition.saleTime)return ElMessage.error('请输入日期');
      if (condition.saleTime)condition.saleTime = moment(condition.saleTime).format("YYYY-MM-DD");
      pager.pageNum = 1;
      queryValue = condition;
      saleFinishToday(condition);
    };

    // 表格特殊行的样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (
        row.column.label === "未退押金金额(元)" ||
        row.column.label === "补缴票款金额(元)"
      ) {
        return "color:red";
      }
      if (row.column.label === "结算金额(元)") {
        return "color: rgb(24, 104, 246)";
      }
    };

    // 初始化列表对象
    const kindList = ref([]);

    const form = ref([
      {
        type: "date",
        label: "日期",
        model: "saleTime",
        placeholder: "请输入日期",
      },
      {
        type: "select",
        label: "码头名称",
        model: "wharfId",
        placeholder: "请选择码头名称",
        options: [],
      },
      {
        type: "select",
        label: "售票员",
        model: "userId",
        placeholder: "请输入售票员",
        options: [],
      },
      {
        type: "select",
        label: "支付方式",
        model: "payWay",
        placeholder: "请选择支付方式",
        options: [],
      },
    ]);

    // 交班
    const shiftHandover = () => {
      proxy.$confirm("确定交班？", "提示").then(async () => {
        const data = await proxy.$api.saleFinishTodayNow();

        // 逻辑等待...

        proxy.$message({
          type: "success",
          message: "交班完成",
        });
      });
    };

    // 获取码头字典
    const saleFinishTodayDict = async () => {
      const { wharfDict, userDict } = await proxy.$api.saleFinishTodayDict();
      // 码头字典添加
      utils.writeDict(wharfDict, form.value[1]);
      // 售票员字典添加
      utils.writeDict(userDict, form.value[2]);
    };

    // 获取数据列表
    const saleFinishToday = async (values) => {
      const params = utils.pageService(pager, values);
      // const { list, totalCount, total } = await proxy.$api.saleFinishToday(params);
      const data = await proxy.$api.saleFinishToday(params);
      kindList.value = data.list;
      total.value = data.total;
      pager.total = data.totalCount;
    };

    // 初始化分页对象
    const pager = reactive({
      pageNum: 1,
      pageSize: 10,
    });

    // 分页事件处理
    const handleCurrentChange = (current) => {
      pager.pageNum = current;
      saleFinishToday(queryValue);
    };

    // 是否展示分页
    const pageShow = ref(true);

    // 定义动态表格-格式
    const columns = reactive([
      {
        label: "日期",
        prop: "_id.saleTime",
      },
      {
        label: "码头名称",
        prop: "beginWharfName",
      },
      {
        label: "售票员",
        prop: "saleUserName",
      },
      {
        label: "船种名称",
        prop: "kindName",
      },
      {
        label: "票种",
        prop: "ticketName",
      },
      {
        label: "支付方式",
        prop: "_id.MyId.payWay",
        formatter(row, column, value) {
          if (value === "crash") {
            return "现金支付";
          } else if (value === "pos") {
            return "POS支付";
          }
        },
      },
      {
        label: "单价(元)",
        prop: "price",
      },
      {
        label: "售票数",
        prop: "totalOrderCount",
      },
      {
        label: "总时长(小时)",
        prop: "timeDuration",
        formatter(row, column, value) {
          return value.toFixed(2);
        },
      },
      {
        label: "结算金额(元)",
        prop: "inPrice",
      },
      {
        label: "未退押金金额(元)",
        prop: "unReturnDeposit",
      },
      {
        label: "补缴票款金额(元)",
        prop: "makeUpPrice",
      },
    ]);
    const { guideTable } = useGuideTable;

    // 导出
    const exportExcel = () => {
      guideTable('/sale/finish/today/export', queryValue);
    };

    saleFinishToday();
    saleFinishTodayDict();
    return {
      formInline,
      form,
      shiftHandover,
      boatKind,
      saleFinishTodayDict,
      pager,
      pageShow,
      columns,
      handleQuery,
      kindList,
      handleCurrentChange,
      total,
      exportExcel,
      cellStyle,
    };
  },
};
</script>

<style scoped lang='less'>
:deep(.el-form-item) {
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }
  padding: 20px;
  margin-bottom: 0;
}
:deep(.el-table__body) {
  .el-table_1_column_11 {
    .cell {
      color: #0079fe;
      font-weight: bold;
    }
  }
}
:deep(.valuation) {
  line-height: 40px;
  span {
    font-weight: bold;
  }
}
</style>
